import logo from 'assets/logo.jpg';
import ixone from 'assets/ixone.png';
import PRODUCT_HUB_LOGO_DEFAULT from 'assets/PRODUCT_HUB_LOGO.png'; 

import PRODUCT_HUB_DEFAULT from 'assets/Blueprint_Logos-ProductHub-Color.png'
import PRODUCT_HUB_WHITE from 'assets/Blueprint_Logos-ProductHub-White.png'

import RIVIR_BACKGROUND_DEFAULT from 'assets/logo_river.png';
import BROOKSHIRE_LOGO_DEFAULT from 'assets/member/brookshire.png';

import emptyFolder from 'assets/folder/empty-folder.png';
import folder from 'assets/folder/folder.png';
import sharedFolder from 'assets/folder/shared-folder.png';
import eulaHeaderBackground from 'assets/pattern/dark_geometric.png';
import eulaFooterBackground from 'assets/pattern/fancy-cushion.png';

import Help from 'assets/Help.svg?react';
 
/**
 * Export all static assets which are defined in assets folder
 */
export const Images = {
  logo,
  ixone,
  emptyFolder,
  folder,
  sharedFolder,
  eulaHeaderBackground,
  eulaFooterBackground,
  PRODUCT_HUB_LOGO_DEFAULT,
  PRODUCT_HUB_DEFAULT,
  RIVIR_BACKGROUND_DEFAULT,
  PRODUCT_HUB_WHITE,
  BROOKSHIRE_LOGO_DEFAULT,
};

export const Svg = {
  Help,
};
